var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-background",on:{"click":function($event){_vm.hide()}}}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_vm._t("header"),_vm._v(" "),_vm._t("content"),_vm._v(" "),_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/common/modals/modal.vue?vue&type=template&id=940f03da
// module id = iB3W
// module chunks = 0